import type { IIndicatorFieldsFragment } from "components/financials/modern/graphql/fragments/__generated__/IndicatorFieldsFragment.generated";
import { noop } from "lodash";
import type { ReactElement } from "react";

type SelectArbitraryIndicatorDebouncerState = {
  debounceMs?: number;
  selectedIndicators?: IIndicatorFieldsFragment[];
  onToggleIndicator?: (
    indicator: IIndicatorFieldsFragment,
    isSelected: boolean,
    bestPlacement?: "START" | "END",
  ) => void;
  onSelectIndicator?: (indicator: IIndicatorFieldsFragment) => void;
};
interface SelectArbitraryIndicatorDebouncerProps extends SelectArbitraryIndicatorDebouncerState {
  children: (state: SelectArbitraryIndicatorDebouncerState) => ReactElement;
}
export default function SelectArbitraryIndicatorDebouncer({
  selectedIndicators = [],
  onSelectIndicator = noop,
  onToggleIndicator = noop,
  children,
}: SelectArbitraryIndicatorDebouncerProps) {
  return children({
    selectedIndicators,
    onSelectIndicator,
    onToggleIndicator,
  });
}
